var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',[_vm._v(_vm._s(_vm.$t("home.header.title")))]),_c('h1',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.$t("home.header.subtitle")))])])}
var staticRenderFns = []

export { render, staticRenderFns }